import "./App.css";

import Contact from "./Sections/Contact/Contact";
import Hero from "./Sections/Hero/Hero";
import NextMove from "./Sections/NextMove/NextMove";
import Projects from "./Sections/Projects/Projects";
import Stages from "./Sections/Stages/Stages";
import Technologies from "./Sections/Technologies/Technologies";
import Testimonials from "./Sections/Testimonials/Testimonials";

function App() {
  return (
    <div className="App">
      <Hero></Hero>
      <Stages></Stages>
      <Projects></Projects>
      <NextMove></NextMove>
      <Technologies></Technologies>
      <Testimonials></Testimonials>
      <Contact></Contact>
    </div>
  );
}

export default App;
